var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('b-badge',{staticClass:"trip-details-status-badge",attrs:{"variant":_vm.tripColorGenerator(_vm.status)}},[_c('span',[_vm._v(_vm._s(_vm.tripStatusFormatter(_vm.status)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }